import { getDefaultMiddleware, configureStore, Action } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';
import { ThunkAction } from 'redux-thunk';
import apiMiddleware from './middlewares/api';
import rootReducer from './rootReducer';

const store = configureStore({
    reducer: rootReducer,
    middleware: [...getDefaultMiddleware({ serializableCheck: false }), apiMiddleware],
    devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools in development
});

export default store;
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

// Export a hook that can be reused to resolve types
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch();
